import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var FilterList = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.016C0 4.438.469 3.97 1.048 3.97h41.904a1.047 1.047 0 1 1 0 2.093H1.048A1.047 1.047 0 0 1 0 5.016ZM6.984 22.42c0-.578.47-1.047 1.048-1.047h27.936a1.047 1.047 0 1 1 0 2.093H8.032a1.047 1.047 0 0 1-1.048-1.046ZM13.968 39.823c0-.578.47-1.047 1.048-1.047h13.968a1.047 1.047 0 1 1 0 2.094H15.016a1.047 1.047 0 0 1-1.048-1.047Z"
  }));
});
FilterList.displayName = 'FilterList';
FilterList.defaultProps = {
  'aria-label': 'FilterList'
};
export default FilterList;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/FilterList.js
// module id = 3786
// module chunks = 11